import React, { useEffect, useState } from 'react';
import BasicTaskListLayout from './layout_01/BasicTaskListLayout';
import axiosInstance from '../../common/utils/interceptor';
import taskItemStatusMapper from '../../taskList/utils/taskItemStatusMapper';
import { Stage } from '../../taskList/interfaces';
import { apiUrls } from '../../constants';
import { filterStageList, stageListMapper } from '../utils/basicStageList';
import { getCandidateMessages, CandidateMessages, psuedoResponse } from '../../common/utils/getCandidateMessages';
import { getTCPlusFormattedDeadlineDate } from '../../common/utils/dateFormatter';
import { getTaskItemList } from '../utils/getTaskItemsList';
import { FullPageLoader } from '../../common/components';
import updateExistingTaskState from '../../taskList/utils/updateExistingTaskState';
import { useBasicResponseReuse } from '../hooks/useBasicResponseReuse';
import { currentWorkflowItemProvider } from '../../store/providers/currentWorkflowItemProvider';
import { useAppSelector } from '../../store/hook';

const BasicTaskListPage = (): React.JSX.Element => {
  const currentWorkflowItems = useAppSelector((state) => state.currentWorkflowItem);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [tasks = [], setTasks] = useState<Stage[]>();
  const [candidateMessages, setCandidateMessages] = useState<CandidateMessages>(psuedoResponse.data);

  const { updateCurrentWorkflowItem } = currentWorkflowItemProvider();
  const projectSettings = useAppSelector((state) => state.projectSettings);
  const deadlineDate = getTCPlusFormattedDeadlineDate(projectSettings.projectEndDate);

  const { isRRApplied, rrPopupInfo } = useBasicResponseReuse(tasks);

  useEffect(() => {
    const fetchTaskList = async (): Promise<void> => {
      try {
        const res = await axiosInstance.get(apiUrls.GET_BASIC_TASKLIST_DETAILS);
        if (res && res.data) {
          let tasks: Stage[] = [];
          if (currentWorkflowItems) {
            const workflowItem = { ...currentWorkflowItems };
            const config = JSON.parse(workflowItem.configuration);
            let stageList = res.data.productListing;
            if (config?.configWidgetJSON?.tasks) stageList = filterStageList(stageList, currentWorkflowItems);
            if (res.data.nestedItemsState?.length)
              stageList = updateExistingTaskState(stageList, res.data.nestedItemsState);
            tasks = taskItemStatusMapper(stageList, workflowItem.nestedItemsState);
            config.configWidgetJSON = { tasks: tasks };
            workflowItem.configuration = JSON.stringify(config);
            updateCurrentWorkflowItem(workflowItem);
          }
          tasks = getTaskItemList(tasks);
          tasks = stageListMapper(tasks);
          setTasks(tasks);
        }
      } catch (e) {
        console.error('Failed while fetching data !', e);
      }
      setIsLoading(false);
    };
    fetchTaskList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    (async (): Promise<void> => {
      const responseData = await getCandidateMessages();
      if (responseData.code === 200) {
        if (responseData.data?.taskListPageContent) setCandidateMessages(responseData.data);
      }
    })();
  }, []);

  if (isLoading) return <FullPageLoader isLoading={isLoading} />;

  return React.createElement(BasicTaskListLayout, {
    data: tasks,
    candidateMessages,
    deadlineDate,
    isRRApplied: isRRApplied,
    rrPopupInfo: rrPopupInfo,
  });
};

export default BasicTaskListPage;
